// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4q-6";
export var headerCell = "_4q-2";
export var rowWrapper = "_4q-4";
export var stickyAggregationCell = "_4q-a";
export var stickyAggregationRow = "_4q-7";
export var stickyColumnCell = "_4q-9";
export var stickyColumnHeaderCell = "_4q-8";
export var table = "_4q-1";
export var virtualRowWrapper = "_4q-5";
export var virtualTableContainer = "_4q-0";
export var white = "_4q-3";